import { Component, Input } from '@angular/core';
import { CampaignStatus } from '../../../core/interfaces';

@Component({
  selector: 'campaign-status-icon',
  templateUrl: './status-icon.component.html',
  styles: [
    `
      :host {
        margin: 8px;
      }
    `,
  ],
  standalone: false,
})
export class StatusIconComponent {
  @Input() status: CampaignStatus;
}
